import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad5792e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CarPuchase" }
const _hoisted_2 = {
  key: 0,
  class: "content-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-container"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "flex-row-centered" }
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contractIdsSearchInput" }, "Filter by Contract Ids:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "selection-form-btn" }, " Search ", -1))
const _hoisted_11 = ["disabled"]

import { ref, computed, onMounted, inject } from "vue";
import { useRoute } from "vue-router";
// Services
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";
import useCarPurchaseVars from "@/services/helpers/CarPurchases/CarPurchasesVariables";
import {
    ParseCarPurchaseCarSaleInvoices,
    FilterCarSaleInvoicesByContractIds,
} from "@/services/helpers/CarPurchases/CarPurchasesFunctions";
// Data
import { ICarPurchasesCarSaleInvoice } from "@/Interfaces/CarPurchases/ICarPurchasesCarSaleInvoice";
import { CarPurchasesCarSaleInvoice } from "@/models/CarPurchases/CarPurchasesCarSaleInvoice";
// Components
import ErrorInfo from "@/components/ErrorInfo.vue";
import Table, {ITableExpose, KeyTypeKeys} from "@/components/TablePersistentChecking.vue";
import TickCrossBooleanDisplay from "@/components/TickCrossBooleanDisplay.vue";
import CarPurchasesPopup from '@/components/CarPurchases/CarPurchasesPopup.vue';
// Misc
import log from "loglevel";
import { AxiosResponse } from "axios";
import { apiLoggerKey } from "@/types/ServiceKeys";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import DatePeriod from "@/types/DatePeriod";
import PeriodSelector from "@/components/PeriodSelector.vue";
import GroupedInputButton from "@/components/GroupedInputButton.vue";

const fileName = "CarPurchase.vue";
const contractIdSearchInputPlaceholder = "Enter comma-seraparated Contract IDs...";

const colKey: KeyTypeKeys<CarPurchasesCarSaleInvoice> = 'INVOICE_ID';

export default /*#__PURE__*/_defineComponent({
  __name: 'CarPurchase',
  setup(__props) {

const GettingCarPurchasesErrorInfo = ErrorInfo;

log.trace("CarPurchase");
const Logger = inject(apiLoggerKey);
const {
    market,
    carPurchasesDefaultSortCols,
    carPurchasesDefaultSortOrders,
    isLoading,
    carPurchasesServices,
    selectedContractOwner,
} = useCarPurchaseVars();

//table
const infoError = ref();
const carSaleInvoiceCols: (keyof CarPurchasesCarSaleInvoice)[] = [
	"CONTRACT_ID",
	"INVOICE_ID",
	"COLLECTIVE_INVOICE_ID",
	"MARKET",
	"AMOUNT_TOTAL",
	"AMOUNT_EX_VAT",
	"AMOUNT_VAT",
	"ISSUE_DATE",
	"BALANCE",
	"BALANCE_DATE_UPDATED",
	"JOURNAL_STATUS",
	"APPROVED_FOR_PAYMENT",
];
const carSaleInvoiceLabels = [
	"Contract Id",
	"Invoice Id",
	"Collective Invoice Id",
	"Market",
	"Amount Total",
	"Amount Ex. VAT",
	"Amount VAT",
	"Issue Date",
	"Balance",
	"Balance Date Updated",
	"Journal Status",
	"Approved for Payment",
];
const carPurchasePage = ref(1);
const carPurchaseRowCount = ref(40);
const carPurchasesCarSaleInvoice = ref<CarPurchasesCarSaleInvoice[]>();
const displayedCarSaleInvoices = computed(
    ()=>FilterCarSaleInvoicesByContractIds(contractIds.value,FilterByDateRangeSelection(carPurchasesCarSaleInvoice.value))
);

//inputs
const period = ref(new DatePeriod());
const popupSaleIds = ref<CarPurchasesCarSaleInvoice[]>();
const contractIds = ref<string>();

//component refs
const table = ref<ITableExpose<CarPurchasesCarSaleInvoice>>();

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////

// ROUTE
const route = useRoute();
market.value = route.params.market as string;

onMounted(async () => {
    document.title = route.name?.toString() + ' - UV';

    const tableProm = GetCarPurchase();
    await tableProm;
});
async function GetCarPurchase() {
    log.trace("GetCarPurchase()");

    const name = GetCarPurchase.name;
    const Class = fileName + "/" + name;
    const collectiveInvoiceId = route.params.id instanceof Array ? route.params.id[0] : route.params.id;
    var Message = `Getting Car Purchases: (collectiveInvoiceId: ${collectiveInvoiceId}, market: ${market.value})`;

    log.debug(`${name}()\n${Message}`);
    try {
        isLoading.value = true;
        carPurchasesCarSaleInvoice.value = undefined;
        const response: AxiosResponse<ICarPurchasesCarSaleInvoice[]> = await carPurchasesServices.GetCarSaleInvoice<ICarPurchasesCarSaleInvoice[]>(collectiveInvoiceId);
        carPurchasesCarSaleInvoice.value = response.data
            .map(ParseCarPurchaseCarSaleInvoices)
            .filter(carSaleInvoice =>
                (carSaleInvoice.BALANCE ?? 0) > 0
            );

        table.value?.ClearChecked();
        Logger?.LogInformation(Message, Class);
    } catch (error) {
        infoError.value = error;
        Message = `(Error) ${Message}: ${error}`;
        log.error(`${Message}`);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
/*
    Updates fetched data when dateRangeSelection changes.
    Triggered by dateRangeSelection.change.
*/
function FilterByDateRangeSelection(data?: CarPurchasesCarSaleInvoice[]) {
    return data?.filter(carPurchase => period.value.within(carPurchase.ISSUE_DATE));
}
function AssignCarPurchaseToOwner() {
    if (popupSaleIds.value) return;
    const checkedItems = table.value?.GetChecked();
    if (!checkedItems?.length) {
        useNotifierWithErrFormatter().notify({ msg: 'No invoice has been selected.' });
        return;
    }
    // Reset Selector
    selectedContractOwner.value = "";
    popupSaleIds.value = checkedItems;
}
function submitContractIdFilter(e: Event) {
    const el = ((e as SubmitEvent).submitter as Element)
    contractIds.value = (el?.parentElement?.children[0] as HTMLInputElement)?.value;
    log.debug(submitContractIdFilter.name, e,contractIds.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(GettingCarPurchasesErrorInfo), {
              showError: !!infoError.value,
              errorDescription: "(Getting Car Purchase)",
              error: infoError.value,
              change: !!infoError.value
            }, null, 8, ["showError", "error", "change"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(PeriodSelector, {
                modelValue: period.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
                showTitle: "",
                hasNullSelector: "",
                filter: (p)=>carPurchasesCarSaleInvoice.value?.some(x=>p.within(x.ISSUE_DATE))
              }, null, 8, ["modelValue", "filter"]),
              _createElementVNode("form", {
                class: "flex-col-centered",
                style: {"row-gap":"5px"},
                onSubmit: _withModifiers(submitContractIdFilter, ["prevent"])
              }, [
                _hoisted_9,
                _createVNode(GroupedInputButton, null, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      id: "contractIdsSearchInput",
                      type: "text",
                      style: _normalizeStyle(`min-width: calc(${contractIdSearchInputPlaceholder.length}ch); flex: 1;`),
                      placeholder: contractIdSearchInputPlaceholder
                    }, null, 4),
                    _hoisted_10
                  ]),
                  _: 1
                })
              ], 40, _hoisted_8),
              _createElementVNode("button", {
                class: "centre-button",
                onClick: AssignCarPurchaseToOwner,
                style: {"padding-left":"1rem","padding-right":"1rem"},
                disabled: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CarPurchasesAssignToOwner)
              }, " Purchase Cars ", 8, _hoisted_11)
            ])
          ]),
          _createVNode(CarPurchasesPopup, {
            modelValue: popupSaleIds.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupSaleIds).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(Table, {
            ref_key: "table",
            ref: table,
            Rows: displayedCarSaleInvoices.value,
            Cols: carSaleInvoiceCols,
            Labels: carSaleInvoiceLabels,
            ColKey: colKey,
            HasCheckBox: "",
            RowCheckableFilter: x=>x.APPROVED_FOR_PAYMENT ?? false,
            CheckIncludesNonDisplayed: "",
            DefaultSortCols: _unref(carPurchasesDefaultSortCols),
            DefaultSortOrders: _unref(carPurchasesDefaultSortOrders),
            RowsPerPage: carPurchaseRowCount.value,
            "onUpdate:RowsPerPage": _cache[2] || (_cache[2] = ($event: any) => ((carPurchaseRowCount).value = $event)),
            Page: carPurchasePage.value,
            "onUpdate:Page": _cache[3] || (_cache[3] = ($event: any) => ((carPurchasePage).value = $event)),
            HasError: !!infoError.value
          }, {
            AMOUNT_TOTAL: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.AMOUNT_TOTAL)), 1)
            ]),
            AMOUNT_EX_VAT: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.AMOUNT_EX_VAT)), 1)
            ]),
            AMOUNT_VAT: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.AMOUNT_VAT)), 1)
            ]),
            BALANCE: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.BALANCE)), 1)
            ]),
            APPROVED_FOR_PAYMENT: _withCtx(({ value }) => [
              _createVNode(TickCrossBooleanDisplay, {
                value: value.APPROVED_FOR_PAYMENT
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["Rows", "RowCheckableFilter", "DefaultSortCols", "DefaultSortOrders", "RowsPerPage", "Page", "HasError"])
        ]))
  ]))
}
}

})